import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema, RevisionIdSchema } from "../primitives/ids.js";
import { QualityGateStatusSchema } from "./quality-gate-result.js";
import { LaunchProofAggregateStatusSchema, LaunchProofPhase1SectionV1Schema, LaunchProofSearchReadinessExcerptV1Schema, } from "./launch-proof-report.js";
/** InternalLaunchProofViewV1 — Studio / agency route DTO. */
export const InternalLaunchProofViewV1Schema = z
    .object({
    schemaVersion: z.literal("internal-launch-proof-view.v1.0"),
    proofReferenceLabel: z.string().min(1),
    aggregateStatus: LaunchProofAggregateStatusSchema,
    headline: z.string().min(1),
    phase1Sections: z.array(LaunchProofPhase1SectionV1Schema).min(1),
    searchReadinessExcerpt: LaunchProofSearchReadinessExcerptV1Schema.optional(),
    departureKitSummary: z.string().min(1).optional(),
    qualityGateStatus: QualityGateStatusSchema.optional(),
    managerExceptions: z.array(z.string().min(1)).optional(),
    skippedChecks: z.array(z.string().min(1)).optional(),
    clientMissingInfo: z.array(z.string().min(1)).optional(),
    whatWeDoNotPromise: z.array(z.string().min(1)).min(1),
    launchProofDisclaimers: z.array(z.string().min(1)).min(1),
    agencyId: AgencyIdSchema.optional(),
    projectId: ProjectIdSchema.optional(),
    businessGraphRevisionId: RevisionIdSchema.optional(),
    artifactSetHash: z.string().min(1).optional(),
    generatedAt: z.string().datetime(),
    clientSafe: z.literal(false),
})
    .strict();
export const ClientSafeLaunchProofPhase1SectionV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-launch-proof-phase1-section.v1.0"),
    areaLabel: z.string().min(1),
    statusLabel: z.string().min(1),
    summary: z.string().min(1),
})
    .strict();
export const ClientSafeLaunchProofSearchExcerptV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-launch-proof-search-excerpt.v1.0"),
    headline: z.string().min(1),
    coverageSummary: z.string().min(1),
    staleBanner: z.string().min(1).nullable(),
})
    .strict();
/** ClientSafeLaunchProofViewV1 — portal whitelist; no tenant IDs, hashes, or raw check IDs. */
export const ClientSafeLaunchProofViewV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-launch-proof-view.v1.0"),
    proofReferenceLabel: z.string().min(1),
    aggregateStatusLabel: z.string().min(1),
    headline: z.string().min(1),
    phase1Sections: z.array(ClientSafeLaunchProofPhase1SectionV1Schema).min(1),
    searchReadinessExcerpt: ClientSafeLaunchProofSearchExcerptV1Schema.optional(),
    departureKitSummary: z.string().min(1).optional(),
    whatWeDoNotPromise: z.array(z.string().min(1)).min(1),
    launchProofDisclaimers: z.array(z.string().min(1)).min(1),
    generatedAt: z.string().datetime(),
    clientSafe: z.literal(true),
})
    .strict();
//# sourceMappingURL=launch-proof-views.js.map